const init = () => {
    window.InfoModal = (function () {
        let modalContainer = null
        let title = null
        let body = null
        let acceptButton = null

        let isInitialized = false
        let defaultOptions = {
            title: '',
            body: '',
            acceptLabel: 'OK',
            onAccept: function () {

            }
        }

        let init = function () {
            let template =
                '<div class="modal-back"></div>' +
                '<div class="modal small">' +
                '<header><h2 class="modal-title"></h2></header>' +
                '<div class="content">' +
                '<p class="modal-body-text">Modal body text goes here.</p>' +
                '<footer>' +
                '   <a class="btn primary accept">Confirm</a>' +
                '</footer>' +
                '</div>' +
                '</div>'
            modalContainer = document.createElement('div')
            modalContainer.classList.add('confirmation-modal');
            modalContainer.innerHTML = template

            document.getElementsByTagName('body')[0].appendChild(modalContainer)
            title = modalContainer.getElementsByClassName('modal-title')[0]
            body = modalContainer.getElementsByClassName('modal-body-text')[0]
            acceptButton = modalContainer.getElementsByClassName('accept')[0]
        }

        let hide = function () {
            modalContainer.style.display = 'none'
        }

        let show = function (options) {
            options = options || {}
            if (!isInitialized) {
                init()
            }
            let config = Object.assign({}, defaultOptions, options)
            title.innerHTML = config.title
            body.innerHTML = config.body
            acceptButton.innerHTML = config.acceptLabel
            acceptButton.onclick = function () {
                hide()
                config.onAccept()
            }
            modalContainer.style.display = 'block'
        }

        return {
            show: show,
            hide: hide
        }
    })()
}

export default {
    init
}
